<app-notification-layout
  [desktopImageSrc]="'/img/technical-failure.png'"
  [mobileImageSrc]="'/img/technical-failure.png'"
  [title]="'Ups, no pudimos reconocer tus datos'"
>
  <div class="notif">
    <p class="notif__text">
      Por favor inténtalo nuevamente en 24 horas, mientras tanto disfruta de
      nuestros servicios. Habla con nosotros a través de: *111# o WhatsApp
      3192510001
    </p>

    <div class="notif__actions">
      <button routerLink="/activate-form" class="btn">FINALIZAR</button>
    </div>
  </div>
</app-notification-layout>
